// src/context/AppContext.jsx
import React, { createContext, useContext, useReducer } from 'react';

const AppContext = createContext();

const initialState = {
    currentAnalysis: null,
    analyses: [],
    selectedFrameworks: ['hipe'],
    loading: false,
    error: null,
    toast: null, // { message, severity }
    audience: 'researcher', // researcher, student, worker, investor
};

const appReducer = (state, action) => {
    switch (action.type) {
        case 'SET_ANALYSIS':
            return {
                ...state,
                currentAnalysis: action.payload,
                loading: false,
            };
        case 'SET_ANALYSES':
            return {
                ...state,
                analyses: action.payload,
            };
        case 'SET_FRAMEWORKS':
            return {
                ...state,
                selectedFrameworks: action.payload,
            };
        case 'SET_LOADING':
            return {
                ...state,
                loading: action.payload,
            };
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload,
                loading: false,
                toast: action.payload ? { message: action.payload, severity: 'error' } : null,
            };
        case 'SET_TOAST':
            return { ...state, toast: action.payload };
        case 'CLEAR_TOAST':
            return { ...state, toast: null };
        case 'SET_AUDIENCE':
            return {
                ...state,
                audience: action.payload,
            };
        default:
            return state;
    }
};

export const AppProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within AppProvider');
    }
    return context;
};